// extracted by LIB_CSS_EXTRACT_LOADER
import "./alert-dialog_module.css"
export default {"backdrop":"backdrop-sgOoG_","popup":"popup-u8AvhV","header":"header-qTlVze","footer":"footer-p2EtIp","title":"title-s7wasB","description":"description-VWg8xy","cancel":"cancel-t_6kep"};